// extracted by mini-css-extract-plugin
export default {"group":"yi9Eo0CMOShnTB_eguKg","label":"g9WiTWiIxgcNKy_ZsWLB","collapsed":"CNbICW8xIO12p1V6TB7I"};